import './AppHeader.css';
export var header = '_8j2khp0-3-5-0';